import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=74c992da&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c992da')) {
      api.createRecord('74c992da', component.options)
    } else {
      api.reload('74c992da', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=74c992da&", function () {
      api.rerender('74c992da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IC4VDj3gOnpc/JS/cancellationPolicy.vue"
export default component.exports